import styled from 'styled-components';
import { Dropdown as AntDropdown } from 'antd';

export const Dropdown = styled(AntDropdown)``;
